module.exports = __webpack_public_path__ + "static/SP-dual-20-amp-relay-companion-module-586b71377bbddee8ae557a98f4585594.pdf";